<template>
  <div class="">
    <v-container class="py-0"> 
      <transition name="fade" mode="out-in" appear>
        <PageTitle class="d-block d-md-none">Landlords</PageTitle>
      </transition>

      <transition name="slide-left-fade" mode="out-in" appear>
        <v-tabs
          v-model="tab"
          class="mt-5 mt-sm-1"
          color="tabColor"
          slider-color="tabColor"
          center-active
          background-color="tertiary"
          show-arrows
          height="55"
        >
          <v-tab ripple>
            All
          </v-tab>
          <v-tab ripple>
            No bank details
          </v-tab>
          <v-tab ripple>
            No email address 
          </v-tab>
          <v-tab ripple>
            In arrears 
          </v-tab>
          <v-spacer></v-spacer>
          <span class="d-none d-md-block">
            <PageTitle>Landlords</PageTitle>
          </span>
        </v-tabs>
      </transition>

      <transition name="slide-fade" mode="out-in" appear>
        <div>
          <v-tabs-items v-model="tab" class="pt-2 tertiary">
            <v-tab-item>
              <LandlordsRecordsTable
                :headers="headers"
                :tableData="allRecords"
                :isLoading="isLoadingAll"
                msg="All"
                @paginate="handlePaginationUpdate"
              />            
            </v-tab-item>
            <v-tab-item>
              <LandlordsRecordsTable
                :headers="headers"
                :tableData="landlordsBanklessRecords"
                :isLoading="isLoadingBankless"
                msg="Without bank details"
                @paginate="handlePaginationUpdate"
              />            
            </v-tab-item>
            <v-tab-item>
              <LandlordsRecordsTable
                :headers="headers"
                :tableData="landlordsEmaillessRecords"
                :isLoading="isLoadingEmailless"
                msg="Without email address"
                @paginate="handlePaginationUpdate"
              />           
            </v-tab-item>           
            <v-tab-item>
              <LandlordsRecordsTable
                :headers="headers"
                :tableData="landlordsOwingRecords"
                :isLoading="isLoadingOwing"
                msg="Owing"
                showTotPayments="true"
                @paginate="handlePaginationUpdate"
              />            
            </v-tab-item>  
          </v-tabs-items>
        </div>
      </transition>

      <v-row>
        <v-col cols="12">
          <v-expansion-panels multiple class="mt-8">
            <v-expansion-panel>
              <v-expansion-panel-header ripple class="secondary lighten-3 white--text" >
                <div class="d-flex align-center justify-start">
                  <!-- <v-icon class="mr-3" color="white">mdi-account-tie</v-icon> -->
                  <v-icon class="mr-3" color="white">mdi-pencil</v-icon>
                  Edit Landlord
                </div>
                <template v-slot:actions>
                  <v-icon color="white">$expand</v-icon>
                </template>
                </v-expansion-panel-header>
              <v-expansion-panel-content>
                <EditLandlords />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
        
    </v-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import LandlordsRecordsTable from '../components/Landlords/LandlordsRecordsTable.vue'
import EditLandlords from '@/components/Edits/EditLandlord.vue'
import PageTitle from '@/components/Slots/PageTitle.vue';

export default {
  components: {
    LandlordsRecordsTable,
    EditLandlords,
    PageTitle
  },
  data() {
    return {
      tab: null,
      headers: [
      {
        text: 'Name',
        align: 'left',
        value: 'LandlordName',
      },
      { text: 'Address', value: 'LandlordAddress' },
      { text: 'Balance', value: 'LandlordAccountBalance', sortable: true, sort: (a, b) => b - a  },
      { text: 'Account no.', value: 'LandlordAccountNumber' },
      // { text: 'E-mail', value: 'LandlordEmail' },
      // { text: 'Support', value: 'Message' },
      { text: '', value: 'actions', align: 'end' },
    ],
    pagination: {
      all: { page: 1, itemsPerPage: 10 },
      bankless: { page: 1, itemsPerPage: 10 },
      emailless: { page: 1, itemsPerPage: 10 },
      owing: { page: 1, itemsPerPage: 10 },
      tenPercent: { page: 1, itemsPerPage: 10 }
    },
    loadedTabs: {
      all: false,
      bankless: false,
      emailless: false,
      owing: false
    }
    }
  },
  created() {
    // Only load the first tab on initial load
    this.loadAllLandlords()
    this.loadedTabs.all = true
  },
  watch: {
    tab(newTab) {
      // Load data for the selected tab if not already loaded
      const tabMap = {
        0: 'all',
        1: 'bankless',
        2: 'emailless',
        3: 'owing'
      }
      
      const tabType = tabMap[newTab]
      if (tabType && !this.loadedTabs[tabType]) {
        this.loadTabData(tabType)
        this.loadedTabs[tabType] = true
      }
    }
  },
  computed: {
    ...mapState({
        allRecords: state => ({
          Data: state.LandlordsRecords.allLandlordRecords,
          Count: state.LandlordsRecords.totalCount.all
        }),
        landlordsBanklessRecords: state => ({
          Data: state.LandlordsRecords.landlordsBanklessRecords,
          Count: state.LandlordsRecords.totalCount.bankless
        }),
        landlordsEmaillessRecords: state => ({
          Data: state.LandlordsRecords.landlordsEmaillessRecords,
          Count: state.LandlordsRecords.totalCount.emailless
        }),
        landlordsOwingRecords: state => ({
          Data: state.LandlordsRecords.landlordsOwingRecords,
          Count: state.LandlordsRecords.totalCount.owing
        }),
        landlordsTenPercentBalanceDifference: state => ({
          Data: state.LandlordsRecords.landlordsTenPercentBalanceDifference,
          Count: state.LandlordsRecords.totalCount.tenPercent
        }),
        loadingStates: state => state.LandlordsRecords.loading
    }),
    isLoadingAll() {
      return this.loadingStates.all
    },
    isLoadingBankless() {
      return this.loadingStates.bankless
    },
    isLoadingEmailless() {
      return this.loadingStates.emailless
    },
    isLoadingOwing() {
      return this.loadingStates.owing
    }
  },
  methods: {
    async loadTabData(tabType) {
      switch(tabType) {
        case 'all':
          await this.loadAllLandlords()
          break
        case 'bankless':
          await this.loadBanklessLandlords()
          break
        case 'emailless':
          await this.loadEmaillessLandlords()
          break
        case 'owing':
          await this.loadOwingLandlords()
          break
      }
    },
    async loadAllLandlords(page = 1, itemsPerPage = null, filters = {}) {
      if (itemsPerPage !== null) {
        this.pagination.all.itemsPerPage = itemsPerPage
      }
      const offset = (page - 1) * this.pagination.all.itemsPerPage
      await this.$store.dispatch('LandlordsRecords/getAllLandlordsRecords', {
        offset,
        limit: this.pagination.all.itemsPerPage,
        forceRefresh: itemsPerPage !== null, // Force refresh when items per page changes
        ...filters
      })
      this.pagination.all.page = page
    },
    async loadBanklessLandlords(page = 1, itemsPerPage = null, filters = {}) {
      if (itemsPerPage !== null) {
        this.pagination.bankless.itemsPerPage = itemsPerPage
      }
      const offset = (page - 1) * this.pagination.bankless.itemsPerPage
      await this.$store.dispatch('LandlordsRecords/getLandlordsBanklessRecords', {
        offset,
        limit: this.pagination.bankless.itemsPerPage,
        forceRefresh: itemsPerPage !== null,
        ...filters
      })
      this.pagination.bankless.page = page
    },
    async loadEmaillessLandlords(page = 1, itemsPerPage = null, filters = {}) {
      if (itemsPerPage !== null) {
        this.pagination.emailless.itemsPerPage = itemsPerPage
      }
      const offset = (page - 1) * this.pagination.emailless.itemsPerPage
      await this.$store.dispatch('LandlordsRecords/getLandlordsEmaillessRecords', {
        offset,
        limit: this.pagination.emailless.itemsPerPage,
        forceRefresh: itemsPerPage !== null,
        ...filters
      })
      this.pagination.emailless.page = page
    },
    async loadOwingLandlords(page = 1, itemsPerPage = null, filters = {}) {
      if (itemsPerPage !== null) {
        this.pagination.owing.itemsPerPage = itemsPerPage
      }
      const offset = (page - 1) * this.pagination.owing.itemsPerPage
      await this.$store.dispatch('LandlordsRecords/getLandlordsOwingRecords', {
        offset,
        limit: this.pagination.owing.itemsPerPage,
        forceRefresh: itemsPerPage !== null,
        ...filters
      })
      this.pagination.owing.page = page
    },
    async loadTenPercentLandlords(page = 1, itemsPerPage = null, filters = {}) {
      if (itemsPerPage !== null) {
        this.pagination.tenPercent.itemsPerPage = itemsPerPage
      }
      const offset = (page - 1) * this.pagination.tenPercent.itemsPerPage
      await this.$store.dispatch('LandlordsRecords/getLandlordsTenPercentDifferenceRecords', {
        offset,
        limit: this.pagination.tenPercent.itemsPerPage,
        forceRefresh: itemsPerPage !== null,
        ...filters
      })
      this.pagination.tenPercent.page = page
    },
    handlePaginationUpdate(type, page, itemsPerPage, filters = {}) {
      // Mark tab as loaded when user interacts with pagination
      if (!this.loadedTabs[type]) {
        this.loadedTabs[type] = true
      }
      
      // Update pagination state immediately for responsive UI
      this.pagination[type].page = page
      if (itemsPerPage) {
        this.pagination[type].itemsPerPage = itemsPerPage
      }
      
      switch(type) {
        case 'all':
          this.loadAllLandlords(page, itemsPerPage, filters)
          break
        case 'bankless':
          this.loadBanklessLandlords(page, itemsPerPage, filters)
          break
        case 'emailless':
          this.loadEmaillessLandlords(page, itemsPerPage, filters)
          break
        case 'owing':
          this.loadOwingLandlords(page, itemsPerPage, filters)
          break
        case 'tenPercent':
          this.loadTenPercentLandlords(page, itemsPerPage, filters)
          break
      }
    }
  }
}
</script>

